// logo 链接地址
export const logoLink = '/restapi/overview';

// 导航栏菜单，及首页的展示
export const menus = [
  {
    type: 'restapi',
    title: '开放API',
    icon: 'restapi',
    desc: '荟聚开放API让您能够通过编程的方式与荟聚交互。使用Open API来做线索、线索行为、线索标签、线索群组、订单等数据的接入和导出。',
    link: '/restapi/overview',
    target: 'innerLink',
  }/*,
  {
    type: 'openhub',
    title: '开放平台',
    icon: 'openhub',
    desc: 'Convertlab 开放平台',
    link: '/openhub/private/',
    target: 'innerLink',
  }*/,
  {
    type: 'trackevent',
    title: '数据采集',
    icon: 'trackevent',
    desc: '数据采集',
    link: '/trackevent/site_collection_guide',
    target: 'innerLink',
  },
  {
    type: 'webhook',
    title: 'Webhook',
    icon: 'trackevent',
    desc: 'Webhook',
    link: '/webhook/webhook-intro',
    target: 'innerLink',
  }
]
